import { z } from "zod";
import { schemes } from "@zeal/common";
import { partnerBusinessDocumentItemSchema } from "../listPartnerBusinessDocuments/listPartnerBusinessDocuments.schema";

export const getPartnerUBODocumentParamsSchema = z.object({
  whiteLabelID: schemes.uuid(),
  first_name: z.string(),
  last_name: z.string(),
});

export type TGetPartnerUBODocumentParams = z.infer<
  typeof getPartnerUBODocumentParamsSchema
>;

export const getPartnerUBODocumentResponseSchema = z.object({
  ubo_document: partnerBusinessDocumentItemSchema.optional(),
});

export type TGetPartnerUBODocumentResponse = z.infer<
  typeof getPartnerUBODocumentResponseSchema
>;
